import React, { useState, useEffect, useRef } from 'react';
import ReactDOM from 'react-dom';
import { useTranslation } from 'react-i18next';
import { ListItemText, MenuItem } from '@mui/material';
import { withStyles } from '@mui/styles';

const StyledMenuItem = withStyles((theme) => ({
  root: {
    width: '275px',
    '&:hover': {
      color: '3c3c3c',
      backgroundColor: 'rgba(255, 228, 38, 0.4);',
    },
    '&:focus': {
      color: '3c3c3c',
      backgroundColor: 'rgba(255, 228, 38, 0.4);',
    },
  },
}))(MenuItem);

const PopoverSpotMenu = (props) => {
  const { t } = useTranslation();
  const [isVisible, setIsVisible] = useState(false);
  const popoverRef = useRef(null);
  const buttonRef = useRef(null);
  const [dropdownPos, setDropdownPos] = useState({ top: 0, left: 0 });

  useEffect(() => {
    // Function to handle clicks outside the popover
    const handleClickOutside = (event) => {
      if (popoverRef.current && !popoverRef.current.contains(event.target) &&
        !event.target.closest('.popover-spot-menu-dropdown')
      ) {
        setIsVisible(false);
      }
    };
    if (isVisible) document.addEventListener('mousedown', handleClickOutside);
    return () => document.removeEventListener('mousedown', handleClickOutside);
  }, [isVisible]);

  const handleClick = () => {
    if (!isVisible && buttonRef.current) {
      const rect = buttonRef.current.getBoundingClientRect();
      // Use absolute positioning on body: viewport position + scroll offset
      setDropdownPos({
        top: rect.bottom + window.scrollY - 8,
        left: rect.left + window.scrollX,
      });
    }
    setIsVisible((prev) => !prev);
  };

  const dropdown = (
    <div
      className="popover-spot-menu-dropdown"
      style={{
        position: 'absolute',
        top: dropdownPos.top,
        left: dropdownPos.left,
        backgroundColor: '#fff',
        boxShadow: '0 2px 4px rgba(0, 0, 0, 0.2)',
        padding: '8px',
        borderRadius: '15px',
        zIndex: 2,
        maxHeight: '400px',
        overflowY: 'auto',
      }}
    >
      {props.list.map((option, index) => (
        <StyledMenuItem
          key={index}
          selected={props.selectedStatus.includes(option.status)}
          onClick={() => props.toggleStatus(option.status)}
          style={
            props.selectedStatus.includes(option.status)
              ? { backgroundColor: '#F9D53F' }
              : { backgroundColor: 'transparent' }
          }
        >
          <ListItemText
            style={{
              textAlign: 'left',
              fontFamily: 'Poppins',
              fontWeight: '400',
              fontSize: '16px',
            }}
            primary={props.getOptionLabel(option)}
          />
          {props.selectedStatus.includes(option.status) ? (
            <img
              style={{ float: 'right' }}
              src="Images/icon-check.png"
              alt="check"
            />
          ) : null}
        </StyledMenuItem>
      ))}
    </div>
  );
  return (
    <div ref={popoverRef}>
      <div ref={buttonRef} onClick={handleClick}>{props.children}</div>
      {isVisible && ReactDOM.createPortal(dropdown, document.body)}
    </div>
  );
};

export default PopoverSpotMenu;